import { type } from "os";

// import axios from "axios";
import Cookie from "js-cookie";
// import appUrls from "../../../helpers/environment";

export default {
    "communication-producing-advisors": [
        {
            "full-name": "Cliff Weiler",
            "title": "1"
        },
        {
            "full-name": "Bobby Wilkes",
            "title": "1"
        }
    ],
    "communication-frequency": {},
    "expenses-salary": "123",
    "expenses-utilities": "456",
    "general-describe-services": "We provide the best services around",
    "general-hardcopy": "yes",
    "general-niche": "no",
    "general-practice-type": {
        "osj": true
    },
    "company-other-business-activity": [
        {
            "name": "First OBA",
            "ownership": 11,
            "entity-type": 0,
            "included": "yes"
        },
        {
            "name": "Second OBA",
            "ownership": 22,
            "entity-type": 3,
            "included": "no"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/succession-archive/data/values.js